import { AUTH_TOKENS } from "constants/storageKeys";

export const getStoredUserEmail = (): string | undefined => {
  try {
    const authTokens = JSON.parse(localStorage.getItem(AUTH_TOKENS) ?? "null");
    const email = authTokens?.email;

    return typeof email === "string" ? email : undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
